<template>
    <div>
        <modal :allow-cancel="false" :enableCloseButton="false" :allowEscape="false" class="text-center">

            <div class="container">
                <p class="font-title text-xl" v-text="$t('COUNTRY_SWITCH_TITLE')"></p>
                <p v-if="appLocation && userLocation" class="my-6" v-text="$t('COUNTRY_SWITCH_CONTENT', {from: appLocation.content_replace, to: userLocation.content_replace})"></p>

                <div v-if="appLocation && userLocation" class="flags flex justify-center">
                    <a @click="clicked" :href="userLocation.link" class="left pr-4 cursor-pointer">
                        <span class="flag-icon text-4xl" :class="userLocation.icon"></span>
                        <p class="text-sm" v-text="$t('COUNTRY_SWITCH_REDIRECT', {siteName: userLocation.content_replace})"></p>
                    </a>

                    <div @click="clicked" :href="appLocation.link" class="right pl-4 cursor-pointer">
                        <span class="flag-icon text-4xl" :class="appLocation.icon"></span>
                        <p class="text-sm" v-text="$t('COUNTRY_SWITCH_PROCEED', {from: appLocation.content_replace})"></p>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/structure/Modal';

export default {
    name: 'CountrySwitchModal',
    props: {
        appLocation: null,
        userLocation: null,
    },
    components: {
        Modal,
    },
    methods: {
        ...mapMutations({
            countrySwitchHasAnswered: 'account/countrySwitchHasAnswered',
        }),
        clicked() {
            this.countrySwitchHasAnswered(true);
        },
    },
};
</script>
